import React from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { BitbucketRepoReadView } from '@atlassian/jira-servicedesk-insight-attribute-views/src/ui/bitbucket-repo/index.tsx';
import type { CmdbObjectAttributeBitbucketRepo } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/attribute.tsx';

export type Props = {
	attribute: CmdbObjectAttributeBitbucketRepo;
};

export const BitbucketRepoAttribute = (props: Props) => {
	const { attribute } = props;

	return (
		<Wrapper>
			{attribute.objectAttributeValues.map(({ bitbucketRepo: { uuid, avatarUrl, name, url } }) => (
				<BitbucketRepoReadView key={uuid} uuid={uuid} url={url} avatarUrl={avatarUrl} name={name} />
			))}
		</Wrapper>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	display: 'flex',
	flexWrap: 'wrap',
	gap: token('space.100', '8px'),
});
